import { CircularProgress, Grid2, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LicenseStyles } from ".";
import { ReactComponent as Line } from "../../AdminAssets/svg/Line1.svg";
import { ReactComponent as SiteIcon } from "../../AdminAssets/svg/Site_plan.svg";
import { ReactComponent as StorageIcon } from "../../AdminAssets/svg/Storage_plan.svg";
import { ReactComponent as PlanIcon } from "../../AdminAssets/svg/Exp_plan.svg";
import { ReactComponent as NoLicenses } from "../../AdminAssets/svg/NoLicenses.svg";
import CircleProgress from "../CircleProgress/CircleProgress";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomButton from "../../../../GlobalComponents/CustomButton/CustomButton";
import { useNavigate, useParams } from "react-router-dom";
import Handover from "../Handover/Handover";
import NewPopup from "../../../../GlobalComponents/Popup/NewPopup";
import { Actions } from "../../../../redux/constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";
import FormPopup from "../../../../GlobalComponents/FormPopup/FormPopup";
import { cashfreeSubscriptionSessionIdDecrypt } from "../../../../Utils/cashfree";
import { useEmailId } from "../../../../Utils/utils";
import { getRoleInOrg } from "../../../../Utils/organizations";

function Licenses(props) {
  const {
    image: Image,
    planName,
    expiry,
    siteUsage,
    storageUsage,
    planExpiry,
    noPlan,
    parentName,
    sites,
    storage,
    plan,
    sitesLimit,
    storageLimit,
    planLimit,
    selectedOrg,
    singleSite,
    expired,
    basePlan,
    dedicatedHosting,
  } = props;
  const { orgId } = useParams();
  const isMobile = window.innerWidth <= 768;
  const navigate = useNavigate();

  const [isHandover, setIsHandover] = useState(false);
  const [value, setValue] = useState("");
  const [otp, setOtp] = useState(Array(4).fill(""));
  const [selectedCountry, setSelectedCountry] = useState(
    selectedOrg?.country || "",
  );
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [address, setAddress] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [zipCodeError, setZipCodeError] = useState(false);
  const [isSendOtp, setIsSendOtp] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [buttonStep, setButtonStep] = useState("Send OTP");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [priceId, setPriceId] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [isloading, setIsLoading] = useState(false);
  const [isDiscard, setIsDiscard] = useState(false);

  //popup
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
    popupCancelTitle: "",
  });

  const ActivatePopup = (type, message) => {
    if (type === "warning") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Are You Sure You Want to Discard?",
        popupSubtitle:
          "Your changes have not been saved. By discarding, you will lose all unsaved progress. Do you wish to continue?",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupButtonFunction: () => {
          flushStateVariables();
          setPopup({ popupState: false });
          setIsDiscard(false);
        },
        popupCancelFunction: () => {
          setPopup({ popupState: false });
          setIsDiscard(false);
        },
      });
    } else if (type === "no_access") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Only Owner and Super Admin has access",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "no_permission") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "You can only become a separate entity if you have a site.",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
      });
    }
  };

  useEffect(() => {
    if (isDiscard) {
      ActivatePopup("warning");
    }
  }, [isDiscard]);

  const emailId = useEmailId();
  const userRole = getRoleInOrg(emailId, selectedOrg);
  const handleOpenHandover = () => {
    setIsHandover(true);
  };

  const handleSendOtp = () => {
    setIsSendOtp(true);
    setIsLoading(true);
    getStore().dispatch({
      type: Actions.API_GET_OTP,
      data: {
        orgId: selectedOrg?.orgId,
        userId: value,
      },
      meta: {
        onSuccess: () => {
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          setIsLoading(false);
          setActiveStep(1);
        },
        onError: () => {
          setIsLoading(false);
        },
      },
    });
  };

  // Convert the OTP array to a string
  const otpString = otp.join("");

  const handleVerifyOtp = () => {
    setIsLoading(true);
    if (otpString.length !== 4) {
      setErrorMsg("Please enter a valid OTP");
      setIsLoading(false);
      return;
    }
    getStore().dispatch({
      type: Actions.API_VERIFY_OTP,
      data: {
        orgId: selectedOrg?.orgId,
        userId: value,
        otp: otpString,
      },
      meta: {
        onSuccess: (response) => {
          if (response.isApiSuccessful && response?.data === false) {
            setErrorMsg(true);
            setIsLoading(false);
          } else if (response.isApiSuccessful && response?.data !== false) {
            setIsLoading(false);
            setErrorMsg("");
            setButtonStep("Next");
            setActiveStep(2);
            setButtonStep("Select Plan");
          }

          setIsLoading(false);
        },
        onError: () => {
          setActiveStep(1);
          setErrorMsg(true);
          setIsLoading(false);
        },
      },
    });
  };

  const handleSetNewCountry = () => {
    setIsLoading(true);

    if (!orgId) {
      return;
    }

    getStore().dispatch({
      type: Actions.API_SET_CHILD_ORG_COUNTRY,
      data: {
        orgId: orgId,
        zipCode: zipCode,
        country: selectedCountry,
        state: selectedState,
        city: selectedCity,
        address: address,
      },
      meta: {
        onSuccess: () => {
          setIsLoading(false);
          setActiveStep(3);
        },
        onError: () => {
          setIsLoading(false);
          setActiveStep(2);
        },
      },
    });
  };

  const handleBuyPlan = () => {
    setIsLoading(true);
    if (selectedOrg?.country === "India") {
      getStore().dispatch({
        type: Actions.GET_CASHFREE_CREATE_SUBSCRIPTION,
        data: {
          coupon: "",
          orgId: selectedOrg?.orgId,
          priceId: priceId,
          // address: address,
          // city: selectedCity,
          // state: selectedState,
          // country: selectedCountry,
          // zipCode: zipCode,
        },
        meta: {
          onSuccess: (data) => {
            setIsLoading(false);
            const cleanedData = data.replace(/\\/g, "");
            cashfreeSubscriptionSessionIdDecrypt(cleanedData);
            window.location.reload();
          },
          onError: () => {
            setIsLoading(false);
          },
        },
      });
    } else {
      getStore().dispatch({
        type: Actions.GET_STRIPE_CREATE_SUBSCRIPTION,
        data: {
          couponId: "",
          orgId: selectedOrg?.orgId,
          priceId: priceId,
          // address: address,
          // city: selectedCity,
          // state: selectedState,
          // country: selectedCountry,
          // zipCode: zipCode,
        },
        meta: {
          onSuccess: (data) => {
            setIsLoading(false);
            let newLink = data?.link;
            getStore().dispatch({
              type: Actions.SET_PLAN,
              data: {
                plan: true,
              },
            });
            if (typeof newLink === "string") {
              window.open(newLink, "_blank");
            }
            // window.location.reload();
          },
          onError: () => {
            setIsLoading(false);
          },
        },
      });
    }
  };

  const flushStateVariables = () => {
    setIsHandover(false);
    setValue("");
    setActiveStep(0);
    setOtp(Array(4).fill(""));
    setSelectedCountry(selectedOrg?.country);
    setSelectedCity("");
    setSelectedState("");
    setAddress("");
    setZipCode("");
    setIsSendOtp(false);
    setErrorMsg("");
    setButtonStep("Send OTP");
  };

  const handleNextStep = () => {
    if (buttonStep === "Send OTP") {
      if (value !== "") {
        handleSendOtp();
        setButtonStep("Verify");
        setActiveStep(1);
      }
    } else if (buttonStep === "Verify") {
      handleVerifyOtp();
    } else if (buttonStep === "Select Plan") {
      handleSetNewCountry();
      setButtonStep("Buy Plan");
    } else if (buttonStep === "Buy Plan") {
      handleBuyPlan();
    }
  };

  const handleBack = () => {
    if (activeStep === 3) {
      setActiveStep(2);
      setButtonStep("Select Plan");
    } else if (activeStep === 2) {
      setActiveStep(1);
      setButtonStep("Verify");
    } else if (activeStep === 1) {
      setActiveStep(0);
      setButtonStep("Send OTP");
    } else if (activeStep === 0) {
      setIsHandover(false);
      flushStateVariables();
    }
  };

  const isAddressValid = () => {
    if (
      address === "" ||
      zipCode === "" ||
      zipCodeError === true ||
      selectedCountry === "" ||
      selectedCity === "" ||
      selectedState === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  const isDisabled = () => {
    if (buttonStep === "Send OTP") {
      return value === "";
    } else if (buttonStep === "Verify") {
      return otpString.length !== 4 || errorMsg;
    } else if (buttonStep === "Select Plan") {
      return !isAddressValid();
    } else if (buttonStep === "Buy Plan") {
      return selectedPlan === null;
    }
  };

  const isplan =
    (basePlan && dedicatedHosting === true) ||
    (basePlan && dedicatedHosting === false);

  return (
    <>
      {parentName === undefined ? (
        <>
          {!noPlan ? (
            <Grid2
              className={`${LicenseStyles.licenseContainer} ${
                expired <= 0 && expired !== null ? LicenseStyles.expired : ""
              }`}
            >
              <Grid2 className={LicenseStyles.FlexBox1}>
                <Grid2 className={LicenseStyles.imgContainer}>
                  {planName !== undefined && (
                    <Image className={LicenseStyles.image} />
                  )}
                </Grid2>
                <Grid2 className={LicenseStyles.orgNameContainer}>
                  {isplan && (
                    <span className={LicenseStyles.isPlan}>
                      {dedicatedHosting === true ? "dedicated" : "Kubernetes"}
                    </span>
                  )}
                  <Grid2 className={LicenseStyles.orgName}>
                    {(singleSite ? "SS-" : "MS-") + planName}{" "}
                  </Grid2>
                  <Grid2 className={LicenseStyles.orgEmail}>
                    Managed WordPress Host
                  </Grid2>
                  <Grid2 className={LicenseStyles.orgEmail}>
                    Expire in{" "}
                    <span className={LicenseStyles.highlight}>{expiry}</span>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2>{!isMobile && <Line />}</Grid2>
              {isMobile && <div className={LicenseStyles.dottedLine} />}
              <Grid2 className={LicenseStyles.FlexBox}>
                <Grid2 className={LicenseStyles.licenseChart}>
                  <CircleProgress
                    sites={sites}
                    sitesLimit={sitesLimit}
                    storage={storage}
                    storageLimit={storageLimit}
                    plan={plan}
                    planLimit={planLimit}
                  />
                </Grid2>
                <Grid2>
                  <Grid2 className={LicenseStyles.infoRow}>
                    <Grid2 className={LicenseStyles.icon}>
                      <SiteIcon />
                    </Grid2>
                    <Grid2>
                      <Grid2 className={LicenseStyles.licenseLabel}>
                        Sites
                      </Grid2>
                      <Grid2 className={LicenseStyles.licenseText}>
                        {siteUsage}
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 className={LicenseStyles.infoRow}>
                    <Grid2 className={LicenseStyles.icon2}>
                      <StorageIcon />
                    </Grid2>
                    <Grid2>
                      <Grid2 className={LicenseStyles.licenseLabel}>
                        Storage
                      </Grid2>
                      <Grid2 className={LicenseStyles.licenseText}>
                        {storageUsage}
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 className={LicenseStyles.infoRow}>
                    <Grid2 className={LicenseStyles.icon3}>
                      <PlanIcon />
                    </Grid2>
                    <Grid2>
                      <Grid2 className={LicenseStyles.licenseLabel}>
                        Plan Expire
                      </Grid2>
                      <Grid2 className={LicenseStyles.licenseText}>
                        {planExpiry}
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid2>
          ) : (
            <Grid2 className={LicenseStyles.nolicenseContainer}>
              <Grid2>
                <Grid2>
                  <NoLicenses />
                </Grid2>
                <Grid2 className={LicenseStyles.noPlanText}>
                  You Currently don't have any active plan.
                </Grid2>
              </Grid2>
              <Grid2 className={LicenseStyles.noPlanButton}>
                <Grid2>
                  <Grid2 className={LicenseStyles.noLicenseInfo}>
                    <Grid2>No Licenses</Grid2>
                    <Tooltip
                      title={"Bank transfer can take upto 1 business day."}
                      arrow
                    >
                      <InfoOutlinedIcon className={LicenseStyles.infoIcon} />
                    </Tooltip>
                  </Grid2>
                  <Grid2 className={LicenseStyles.noPlanText1}>
                    Unlock Your Potential. Get Started Today!
                  </Grid2>
                </Grid2>
                <Grid2 className={LicenseStyles.noPlanButton}>
                  <CustomButton
                    onClick={() => {
                      navigate(`/account/${orgId}/modify-plan`);
                    }}
                  >
                    Buy a plan
                  </CustomButton>
                </Grid2>
              </Grid2>
            </Grid2>
          )}
        </>
      ) : (
        <Grid2 className={LicenseStyles.nolicenseContainer}>
          <Grid2>
            <Grid2 className={LicenseStyles.parentOrgIcon}>
              <NoLicenses />
            </Grid2>
          </Grid2>
          <Grid2 className={LicenseStyles.managedByContainer}>
            <Grid2 className={LicenseStyles.managedBy}>
              <Grid2 className={LicenseStyles.managedByText}>
                This org is currently managed by :{" "}
              </Grid2>
              <Grid2 className={LicenseStyles.parentName}>{parentName}</Grid2>
            </Grid2>
            <CustomButton
              onClick={() => {
                if (sites === 0) ActivatePopup("no_permission");
                else if (userRole !== "Owner" && userRole !== "Super Admin") {
                  ActivatePopup("no_access");
                } else {
                  handleOpenHandover();
                }
              }}
            >
              Become a Separate Entity
            </CustomButton>
          </Grid2>
        </Grid2>
      )}

      <NewPopup
        trigger={isHandover}
        closePopup={() => {
          flushStateVariables();
        }}
        header={"Become a Separate Entity"}
        customWidth={"45%"}
        backPopup={
          activeStep === 3 ? "Discard" : activeStep === 3 ? "Close" : "Back"
        }
        backOnClick={() => {
          if (activeStep === 3) {
            setIsHandover(false);
            setIsDiscard(true);
          } else {
            handleBack();
          }
        }}
        nextpopup={
          isloading ? (
            <CircularProgress size={24} color={"inherit"} />
          ) : (
            buttonStep
          )
        }
        nextOnClick={
          value === "" && buttonStep === "Send OTP" ? null : handleNextStep
        }
        disabled={isDisabled()}
      >
        <Handover
          selectedOrg={selectedOrg}
          value={value}
          setValue={setValue}
          sendOtp={handleSendOtp}
          isSendOtp={isSendOtp}
          verifyOtp={handleVerifyOtp}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          otp={otp}
          setOtp={setOtp}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          errorMsg={errorMsg}
          setErrorMsg={setErrorMsg}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          selectedState={selectedState}
          setSelectedState={setSelectedState}
          selectedCity={selectedCity}
          setSelectedCity={setSelectedCity}
          address={address}
          setAddress={setAddress}
          zipCode={zipCode}
          setZipCode={setZipCode}
          zipCodeError={zipCodeError}
          setZipCodeError={setZipCodeError}
          priceId={priceId}
          setPriceId={setPriceId}
        />
      </NewPopup>
      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        popupCancelFunction={popup.popupCancelFunction}
        cancelTitle={popup.popupCancelTitle}
        handover={true}
      />
    </>
  );
}

export default Licenses;
